<template>
    <div style="text-align: center">
        <h2>ตัวอย่างเงินเดือน</h2>
        <div class="row form-group" align="center">
            <div class="col-5 text-right">วิคที่ออกเงินเดือน</div>
            <div class="col-6">
                <select class="form-control"
                        v-model="week">
                    <option value="" hidden>เลือกวิกการจ่ายเงิน</option>
                    <option value="1">วิกที่ 1</option>
                    <option value="2">วิกที่ 2</option>
                </select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-5 text-right">เดือนที่ต้องการคิดเงินเดือน</div>
            <div class="col-6">
                <date-picker
                    :lang="lang"
                    type="month"
                    :format="changeFormat"
                    v-model="date"
                    placeholder="เดือน-ปี"
                    format="MM/YYYY">
                </date-picker>
            </div>
        </div>
        <div class="row form-group" align="center">
            <div class="col-5 text-right">เลือกแผนก</div>
            <div class="col-6">
                <b-form-select v-model="department_id" :options="optionDepartment"></b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-5 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                    :options="optionEmployee"
                    v-model="employee"
                    :customLabel="employeeLabel"
                    select-label=""
                    deselectLabel=""
                    placeholder="พนักงาน"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="col text-center">
            <button  type="button"
                     @click="submitPreviewSalary"
                     class="btn btn-primary">
                <icon name="print" style="width: 25px"></icon>
                พิมพ์
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelPreviewSalary"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <!--        <pre class="alert-success">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import moment from "moment"
    import DatePicker from 'vue2-datepicker'
    import Multiselect from "vue-multiselect";
    export default {
        name: "preview-salary-modal",
        components:{DatePicker,Multiselect},
        created() {
            this.getDepartmentAll();
            this.getEmployeeAll();
        },
        data() {
            return {
                optionEmployee : [],
                optionDepartment : [],
                week: "",
                date : '',
                department_id : '',
                employee : '',
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            };
        },
        computed:{
            ...mapState({

            })
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            submitPreviewSalary(){
                if(!this.department_id && !this.employee){
                    alert('กรุณาเลือกแผนกหรือพนักงานเพื่อออกเงินเดือน')
                }
                else if(!this.week){
                    alert('กรุณาเลือกวิคที่ต้องการออกเงิน')
                }else{
                    if(this.date){
                        this.date = moment(this.date).format('YYYY-MM-DD');
                    }else{
                        this.date = '';
                    }
                    this.$emit("submit",{
                        week : this.week,
                        date : this.date,
                        department_id : this.department_id,
                        employee_id : this.employee ? this.employee.employee_no : '',
                    })
                }
            },
            cancelPreviewSalary(){
                this.$emit("submit",0)
            },
            getEmployeeAll(){
                this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                    this.optionEmployee = res;
                })
            },
            getDepartmentAll(){
                this.$store.dispatch("Department/getAllDepartment").then(res=>{
                    this.optionDepartment = [
                        {
                            value: '',
                            text: "เลือก"
                        },
                        ...res.map(data => ({
                            value: data.id,
                            text: data.department_name
                        }))
                    ]
                })
            },

        }
    }
</script>

<style scoped>

</style>
